module.exports = __webpack_public_path__ + "static/media/find-messages-correct.a75d3bd5.png";